import { createContext } from 'react';

export const EmailContext = createContext({});
export const jwtToken = createContext({});

